module.exports = __webpack_public_path__ + "img/icon_playerNum.4915ad6b.svg";